module.exports = __webpack_public_path__ + "static/img/change.b481fad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/change.png
// module id = Lk8U
// module chunks = 93